var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "tabela-os-detalhe__container" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24, id: "tabela-os-detalhe__colunas" } },
            [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { data: _vm.dados.tecnicos }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "fixed",
                          label: "Nome do técnico",
                          "min-width": "260",
                          prop: "nomeTecnico"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Função",
                          "min-width": "90",
                          prop: "funcaoTecnico"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Aguardando chegar ao técnico",
                          "min-width": "180",
                          align: "center",
                          formatter: _vm.aguardandoAnalisePai
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Aguardando análise",
                          "min-width": "140",
                          align: "center",
                          formatter: _vm.aguardandoAnalise
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Em análise",
                          "min-width": "80",
                          align: "center",
                          formatter: _vm.emAnalise
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Em revisão",
                          "min-width": "80",
                          align: "center",
                          formatter: _vm.emRevisao
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Finalizado",
                          "min-width": "90",
                          align: "center",
                          formatter: _vm.concluido
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Total",
                          "min-width": "60",
                          align: "center",
                          formatter: _vm.total
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("el-row", { attrs: { id: "tabela-detalhe__linha-total" } }, [
        _vm._v("Total geral: " + _vm._s(_vm.totalProcessos))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec8c2050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec8c2050","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/os/TabelaDetalheOS.vue
// module id = null
// module chunks = 